import React from 'react';
import { ThemeProvider, useTheme } from '../ThemeContext';
import {
  HomeBuyerHistory,
  HomeTransferClaimForm,
  HomeTransferSellerForm,
  TransferWordmark,
} from './HomeTransferScreens';

const REPORTS = [{
  id: 'report-preview',
  reportNumber: 'HR-0003',
  version: 3,
  documentCount: 2,
  photoCount: 4,
}];

const ENTRIES = [
  { id: 'hvac', title: 'HVAC filter', detail: 'Completed March 2026' },
  { id: 'roof', title: 'Roof receipt', detail: 'Document attached' },
];

function Frame() {
  const { colors } = useTheme();
  const scene = new URLSearchParams(window.location.search).get('scene') || 'seller';
  const page = {
    minHeight: '100vh',
    background: colors.background,
    color: colors.text,
    padding: '1.25rem',
    boxSizing: 'border-box',
  };
  return (
    <main style={page}>
      <TransferWordmark color={colors.text} />
      {scene === 'claim' ? (
        <HomeTransferClaimForm colors={colors} addressLabel="18 Oak Street, Orlando, FL" onSubmit={() => {}} />
      ) : null}
      {scene === 'home' ? (
        <HomeBuyerHistory
          colors={colors}
          address="18 Oak Street"
          city="Orlando"
          state="FL"
          note="History before 2026-10-20 was recorded by the previous owner and is shown as they shared it."
          entries={ENTRIES}
        />
      ) : null}
      {scene === 'seller' ? (
        <HomeTransferSellerForm
          colors={colors}
          reports={REPORTS}
          initialClosingDate="2026-10-20"
          initialEmail="delivered+buyer@resend.dev"
          onSubmit={() => {}}
        />
      ) : null}
    </main>
  );
}

export default function HomeTransferPreview() {
  const params = new URLSearchParams(window.location.search);
  const theme = params.get('theme') === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem('pacarion_theme', theme);
  } catch (error) {
    // The preview still renders with the stored theme.
  }
  return (
    <ThemeProvider>
      <Frame />
    </ThemeProvider>
  );
}
